import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, permission }) => {
  // const auth = useSelector((state) => state.auth);
  // const isAuthenticated = localStorage.getItem("token"); // เช็คว่ามี token หรือไม่
  const auth = JSON.parse(localStorage.getItem("auth"));
  const isAuthenticated = auth?.data?.permission?.[permission];
  return isAuthenticated ? children : <Navigate to="/" />;
};

export default ProtectedRoute;
